import { Link } from "react-router-dom";

/**
 * Offizielles VM-FFM.DE Emblem — goldenes Schild mit aufsteigendem
 * Wachstums-Pfeil und Balkendiagramm (skalierbare SVG-Marke).
 */
export function LogoMark({ size = 44, className = "" }) {
  return (
    <svg width={size * (120 / 132)} height={size} viewBox="0 0 120 132" fill="none"
      xmlns="http://www.w3.org/2000/svg" className={className} role="img" aria-label="VM-FFM.DE Logo">
      <defs>
        <linearGradient id="vmGold" x1="10" y1="6" x2="110" y2="128" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F5EBC1" />
          <stop offset="0.5" stopColor="#D4AF37" />
          <stop offset="1" stopColor="#8C7326" />
        </linearGradient>
      </defs>
      {/* Schild */}
      <path d="M60 6L108 24V64C108 96 88 120 60 128C32 120 12 96 12 64V24L60 6Z"
        fill="#0A1128" stroke="url(#vmGold)" strokeWidth="6" strokeLinejoin="round" />
      {/* Balken */}
      <rect x="33" y="76" width="14" height="20" rx="1.5" fill="url(#vmGold)" />
      <rect x="53" y="62" width="14" height="34" rx="1.5" fill="#F8F8F8" />
      <rect x="73" y="48" width="14" height="48" rx="1.5" fill="url(#vmGold)" />
      {/* Pfeil */}
      <path d="M28 88L71 53" stroke="url(#vmGold)" strokeWidth="7" strokeLinecap="round" />
      <path d="M90 38L79.5 63.2L63.1 43L90 38Z" fill="url(#vmGold)" stroke="url(#vmGold)" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}

export function Logo({ to = "/", tagline = true, dark = false, size = 44, className = "" }) {
  const wordColor = dark ? "text-navy-900" : "text-white";
  const tagColor = dark ? "text-navy-700/70" : "text-slate-300/80";
  const content = (
    <div className={`flex items-center gap-3 ${className}`}>
      <LogoMark size={size} />
      <div className="leading-none">
        <span className={`font-display font-extrabold ${wordColor} text-xl tracking-tight`}>
          VM-FFM<span className="text-gold-500">.DE</span>
        </span>
        {tagline && (
          <span className={`block font-brand text-[8.5px] tracking-[0.2em] ${tagColor} uppercase mt-1`}>
            Versicherung · Finanzierung · Immobilien
          </span>
        )}
      </div>
    </div>
  );
  if (!to) return content;
  return <Link to={to} data-testid="logo" className="group">{content}</Link>;
}
